/* eslint-env browser, jquery */
/* global wistiaJQuery, WOW, Swiper, TimelineMax, TweenMax, hljs */
import debugT from 'debug';
import container from 'modules/section-content';
import load from 'scriptloader';
import rg from 'modules/npm-component/require-global';
import metrics from 'modules/metrics';
import domify from 'domify';
import 'bootstrap';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import splash from './why-auth0-page.pug';
import metadata from './metadata.json';

const debug = debugT('auth0:why-auth0');

export default function register() {
  page('/jp/why-auth0', render, loadScripts, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TweenMax.min.js', 'TweenMax', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/TimelineMax.min.js', 'TimelineMax', done);
  });

  batch.push(done => {
    load('//cdnjs.cloudflare.com/ajax/libs/gsap/1.16.1/plugins/TextPlugin.min.js', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/highlight.js/8.4/highlight.min.js', 'hljs', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/Swiper/3.0.5/js/swiper.min.js', 'Swiper', done);
  });

  batch.push(done => {
    load('//fast.wistia.com/assets/external/popover-v1.js', done);
  });

  batch.push(done => {
    rg('//fast.wistia.com/assets/external/iframe-api-v1.js', 'wistiaApi', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('body').addClass('loaded');

  if (window.wistiaJQuery) loadWistia();

  const vid = document.getElementById('why-video');

  function playVid() {
    vid.play();
  }

  $('a.play-me-again').on('click', e => {
    e.preventDefault();
    if (window.TimelineMax && window.TweenMax) scene1().resume();
    if (window.wistiaJQuery) playVid();
    metrics.lib().track('replay:get-started-animation');
  });

  $('.js-play-track').click(e => {
    metrics.lib().track('click:video-banner');
  });

  $('[data-toggle="tab"]').on('show.bs.tab', function(ev) {
    const target = $(this).attr('href');
    if ($(target).hasClass('active')) return;
    metrics.lib().track('viewed:old-new-tab', { value: target.slice(1) });
  });

  // show banner
  $('.banner .container h1, .banner .container p')
    .addClass('animated fadeInDown')
    .css('visibility', 'visible');
  $('.banner .container a').addClass('animated fadeInUp').css('visibility', 'visible');

  if (window.WOW) {
    const wow = new WOW({
      boxClass: 'start-steps',
      mobile: true,
      live: true,
      callback() {
        if (window.TimelineMax && window.TweenMax) scene1().resume();
        if (window.wistiaJQuery) playVid();
      }
    });
    wow.init();
  }

  if (window.hljs) hljs.initHighlightingOnLoad();

  $('nav.nav-pills.no-mobile a').hover(function(e) {
    e.preventDefault();
    $('nav.nav-pills.no-mobile a').removeClass('active');
    $(this).click().addClass('active');
  });

  if (window.Swiper) {
    const mySwiper = new Swiper('.swiper-container', {
      slidesPerView: 2,
      centeredSlides: true,
      preventClicks: false,
      preventClicksPropagation: false,
      spaceBetween: 30,
      onSlideChangeEnd() {
        $('a.swiper-slide').removeClass('active');
        $('a.swiper-slide-active').click().addClass('active');
      }
    });
  }

  next();
}

function loadWistia() {
  let transitioned = 0;
  wistiaJQuery(document).bind('wistia-popover-open', () => {
    $('.banner .container h1, .banner .container p').addClass('animated fadeOutUp');
    $('.banner .container a').addClass('animated fadeOutDown');
    metrics.lib().track('open:video-popup');
  });

  wistiaJQuery(document).bind('wistia-popover', (ev, iframe) => {
    transitioned = 0;
    const api = iframe.wistiaApi;
    api.bind('secondchange', s => {
      transitioned = s;
      if (s && !(s % 10)) {
        // every 10 seconds, we trigger a length event
        metrics.lib().track('viewed:video-length', { value: transitioned });
      }
    });
    api.bind('play', () => {
      metrics.lib().track('click:video-play', { value: transitioned });
    });
    api.bind('pause', () => {
      metrics.lib().track('click:video-pause', { value: transitioned });
    });
  });

  wistiaJQuery(document).bind('wistia-popover-close', () => {
    $('.banner .container h1, .banner .container p')
      .removeClass('animated fadeOutUp')
      .addClass('animated fadeInDown');
    $('.banner .container a').removeClass('animated fadeOutDown').addClass('animated fadeInUp');
    metrics.lib().track('close:video-popup', { value: transitioned });
    transitioned = 0;
  });
}

function scene1() {
  const timeline = new TimelineMax({
    onComplete() {
      scene2().resume();
    }
  });

  timeline
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s4').removeClass('active');
      }),
      0
    )
    .to(
      '.play-me-again',
      0,
      {
        display: 'none',
        opacity: 1
      },
      0
    );

  // end reset

  timeline.add(
    TweenMax.delayedCall(0, () => {
      $('.step.s1').addClass('active');
    }),
    0
  );

  timeline.pause();
  return timeline;
}

function scene2() {
  const timeline = new TimelineMax({
    onComplete() {
      scene3().resume();
    }
  });

  timeline
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s1').removeClass('active');
      }),
      4.7
    )
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s2').addClass('active');
      }),
      4.7
    );

  timeline.pause();
  return timeline;
}

function scene3() {
  const timeline = new TimelineMax({
    onComplete() {
      scene4().resume();
    }
  });

  timeline
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s2').removeClass('active');
      }),
      1.5
    )
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s3').addClass('active');
      }),
      1.5
    );

  timeline.pause();
  return timeline;
}

function scene4() {
  const timeline = new TimelineMax({ onComplete: stepScenesComplete });

  timeline
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s3').removeClass('active');
      }),
      6
    )
    .add(
      TweenMax.delayedCall(0, () => {
        $('.step.s4').addClass('active');
      }),
      6
    )
    .to(
      '.play-me-again',
      0.5,
      {
        display: 'block',
        opacity: 1
      },
      15
    );

  timeline.pause();
  return timeline;
}

function stepScenesComplete() {
  debug('scenes completed succesfully!');
}



// WEBPACK FOOTER //
// ./src/pages/jp/why-auth0/why-auth0.js